module.exports = __webpack_public_path__ + "static/media/lttip.32271ffc.png";